import styled, { keyframes } from "styled-components";

const linearAnimation = keyframes`
  0% {
    background-position: left;
  }
  100% {
    background-position: right;
  }
`;

export const StyledSkeletonLoader = styled.div`
  width: 70%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 20%,
    rgba(0, 0, 0, 0.05) 50%,
    rgba(255, 255, 255, 0) 60%
  );
  background-size: 400%;
  height: 16px;
  border-radius: 8px;
  .neon & {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 20%,
      rgba(0, 0, 0, 0.2) 50%,
      rgba(255, 255, 255, 0) 60%
    );
    background-size: 500%;
  }
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-name: ${linearAnimation};
  animation-timing-function: linear;
  animation-direction: reverse;
`;
